const Button = ({
  children,
  size = 'md',
  variant = 'primary',
  startIcon,
  endIcon,
  onClick,
  className = '',
  disabled = false,
  type = 'button',
  ariaLabel,
}) => {
  // Size Classes
  const sizeClasses = {
    sm: 'px-4 py-3 text-sm',
    md: 'px-5 py-2.5 text-sm',
  };

  // Variant Classes
  const variantClasses = {
    primary:
      'bg-brand-500 text-white shadow-theme-xs hover:bg-brand-600 disabled:bg-brand-300',
    outline:
      'border border-gray-300 bg-transparent hover:bg-gray-50 disabled:opacity-50 dark:border-gray-600 dark:bg-transparent dark:hover:bg-gray-800',
  };

  return (
    <button
      type={type}
      className={`inline-flex items-center justify-center gap-2 rounded-lg transition ${className} ${
        sizeClasses[size]
      } ${variantClasses[variant]} ${
        disabled ? 'cursor-not-allowed opacity-50' : ''
      }`}
      onClick={onClick}
      disabled={disabled}
      aria-label={ariaLabel}
    >
      {startIcon && <span className="flex items-center" aria-hidden="true">{startIcon}</span>}
      {children}
      {endIcon && <span className="flex items-center" aria-hidden="true">{endIcon}</span>}
    </button>
  );
};

export default Button;
